import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import createI18n from './utils/i18n-factory'

Vue.use(VueRouter)

/**
 * Client (SPA) app factory.
 * This can use the full route tree.
 */
export function createClientApp(context = {}) {
  const router = new VueRouter({
    mode: 'history',
    routes,
  })

  const i18n = createI18n(context)

  const app = new Vue({
    router,
    i18n,
    render: (h) => h(App),
  })

  return { app, router, i18n }
}
